/**
 * Resolve `public/` asset URLs for AuthShell / Nav chrome.
 * Aligns with @xt/Nav `navPublicAssetUrl` and spikex-pc-rules:
 * production → `{NEXT_PUBLIC_cdn}/public/...`; local/dev → bare `/...`.
 *
 * @param {string} relativePath — e.g. `brand/logo-mark.png`
 */
export function navPublicAssetUrl(relativePath) {
  const rel = `/${String(relativePath || "").replace(/^\/+/, "")}`;
  if (process.env.NEXT_PUBLIC_LOCAL || process.env.NEXT_PUBLIC_DEV || !process.env.NEXT_PUBLIC_cdn) {
    return rel;
  }
  return `${process.env.NEXT_PUBLIC_cdn}/public${rel}`;
}
